import { render } from "./LegalFooter.vue?vue&type=template&id=a0faa750&scoped=true"
import script from "./LegalFooter.vue?vue&type=script&lang=js"
export * from "./LegalFooter.vue?vue&type=script&lang=js"

import "./LegalFooter.vue?vue&type=style&index=0&id=a0faa750&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0faa750"]])

export default __exports__